import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    boxShadow: theme.shadows[1],
    '&:hover': {
      boxShadow: theme.shadows[3],
    }
  },
  clickableArea: {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' 
        ? 'rgba(255, 255, 255, 0.02)' 
        : 'rgba(10, 37, 64, 0.015)', // Um toque quase imperceptível do nosso Navy premium
    },
    '&:hover $chevronIcon': {
      transform: 'translateX(4px)',
      color: theme.palette.secondary.main,
    },
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },

  chevronIcon: {
    transition: 'all 0.2s ease',
    color: theme.palette.text.secondary,
    fontSize: '2rem',
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: '1.1rem',
    color: theme.palette.text.primary,
    letterSpacing: '0.3px',
  },
  metaGrid: {
    padding: theme.spacing(0, 3, 3, 3),
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: '10px',
    backgroundColor: theme.palette.type === 'dark' 
      ? 'rgba(255, 255, 255, 0.03)' // Brilho leitoso sutil no dark mode (elimina o preto absoluto)
      : 'rgba(10, 37, 64, 0.025)', // Névoa Navy sutil para um look limpo no tema claro
    border: theme.palette.type === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.06)'
      : '1px solid rgba(10, 37, 64, 0.05)',
    transition: 'all 0.2s ease',
    height: '100%',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.06)'
        : 'rgba(10, 37, 64, 0.05)',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(10, 37, 64, 0.1)',
    },
  },
  metaIcon: {
    color: theme.palette.icon, // Neutro e elegante (Adeus excesso de azul!) 🧼💎
    fontSize: '1.3rem',
    flexShrink: 0,
  },
  metaTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  metaLabel: {
    fontSize: '0.65rem',
    fontWeight: 700,
    letterSpacing: '1px',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
  metaValue: {
    fontSize: '0.82rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  sectionTitle: {
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '1.5px',
    color: theme.palette.text.secondary,
    paddingBottom: theme.spacing(1),
    borderBottom: `1px dashed ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
  },
  contentArea: {
    padding: theme.spacing(0, 3, 3, 3),
  },
}))

export default useStyles
